import {
  useContext,
  createContext,
  useState,
  type Dispatch,
  type SetStateAction,
  type PropsWithChildren,
} from 'react';

/**
 * パスワード付きのリクエストが失敗したかどうかの state
 */
const isPasswordInvalidContext = createContext<boolean>(false);
const setIsPasswordInvalidContext = createContext<
  Dispatch<SetStateAction<boolean>>
>(() => undefined);

export function IsPasswordInvalidProvider({
  children,
  initialValue,
}: PropsWithChildren<{readonly initialValue?: boolean}>) {
  const [isPasswordInvalid, setIsPasswordInvalid] = useState<boolean>(
    initialValue ?? false,
  );

  return (
    <isPasswordInvalidContext.Provider value={isPasswordInvalid}>
      <setIsPasswordInvalidContext.Provider value={setIsPasswordInvalid}>
        {children}
      </setIsPasswordInvalidContext.Provider>
    </isPasswordInvalidContext.Provider>
  );
}

export function useIsPasswordInvalid() {
  return useContext(isPasswordInvalidContext);
}

export function useSetIsPasswordInvalid() {
  return useContext(setIsPasswordInvalidContext);
}
